import * as types from './actionTypes';  
import showAllocationApi from '../api/showAllocationApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchShowAllocation(params, isLoading) {

  return {
    type: types.DO_FETCH_SHOW_ALLOCATION,
    params, isLoading
  };
}

export function doFetchShowAllocationRes(data) {  
  return {
    type: types.DO_FETCH_SHOW_ALLOCATION_RES, 
    data
  };
}
export function fetchShowAllocations(params, isLoading) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      if (isLoading) {
        dispatch(loadingRes(true));
      }
      showAllocationApi.doFetchShowAllocation(params).then(data => {
        dispatch(doFetchShowAllocationRes(data));
        dispatch(doFetchShowAllocationRes(null));
        if (isLoading) {
          dispatch(loadingRes(false));
        }
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        if (isLoading) {
          dispatch(loadingRes(false));
        }
        return error
      });
    };
  }else{
    logout()
  }
  
}